module.exports = __webpack_public_path__ + "static/img/S6.96addc3a.png";